/**
 * Tiny CSV downloader for the admin dashboard.
 * Triggers a download in the browser with the given content + filename prefix.
 */
const downloadCSV = (content, filenamePrefix) => {
  const blob = new Blob([content], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filenamePrefix}-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

const escape = (val) => `"${String(val ?? '').replace(/"/g, '""')}"`;

export const exportSignupsCSV = (signups, formatDate) => {
  const headers = ['Player Name', 'Age', 'Parent/Guardian', 'Email', 'Phone', 'Status', 'Signup Date'];
  const lines = [
    headers.join(','),
    ...signups.map((s) =>
      [
        escape(s.player_name),
        s.age,
        escape(s.parent_name),
        escape(s.email),
        escape(s.phone),
        s.status,
        escape(formatDate(s.created_at)),
      ].join(',')
    ),
  ];
  downloadCSV(lines.join('\n'), 'ota-signups');
};

export const exportContactsCSV = (contacts, formatDate) => {
  const headers = ['Name', 'Email', 'Phone', 'Subject', 'Message', 'Status', 'Date'];
  const lines = [
    headers.join(','),
    ...contacts.map((c) =>
      [
        escape(c.name),
        escape(c.email),
        escape(c.phone || ''),
        escape(c.subject),
        escape(c.message),
        c.status,
        escape(formatDate(c.created_at)),
      ].join(',')
    ),
  ];
  downloadCSV(lines.join('\n'), 'contact-submissions');
};
